module.exports = __webpack_public_path__ + "img/team-3.fed3e4a5.jpg";